import React from 'react';
import './totals-section.css';

const TotalsSection = (props) => {
  const {
    authorableContent: {
      estimatedCostAllSitesText,
      usersText,
      costText,
      usersToTipt,
      usersToLiberate,
      perMonthTotalText,
      totalText,
    },
    tiptCost,
    liberateCost,
    allSitesCost,
    tiptUsers,
    liberateUsers,
    allSitesUsers,
  } = props;

  return (
    <div className="totals-section">
      <div className="row">
        <div className="col-12 heading24">
          {estimatedCostAllSitesText}
        </div>
      </div>
      <div className="row heading-row mr-0">
        <div className="col-8">
            &nbsp;
        </div>
        <div className="col-2 heading16">
          {usersText}
        </div>
        <div className="col-2 heading16">
          {costText} <br /> {perMonthTotalText}
        </div>
      </div>
      <div className="row border-row mr-0">
        <div className="col-8">
          {usersToTipt}
        </div>
        <div className="col-2">
          {tiptUsers}
        </div>
        <div className="col-2">
          {tiptCost}
        </div>
      </div>
      <div className="row border-row mr-0">
        <div className="col-8">
          {usersToLiberate}
        </div>
        <div className="col-2">
          {liberateUsers}
        </div>
        <div className="col-2">
          {liberateCost}
        </div>
      </div>
      <div className="row border-row mr-0">
        <div className="col-8 heading16">
          {totalText}
        </div>
        <div className="col-2">
          {allSitesUsers}
        </div>
        <div className="col-2">
          {allSitesCost}
        </div>
      </div>
    </div>
  );
};

export default TotalsSection;
